import { useEffect } from "react";
import { brand } from "./theme";

const SCRIPT_ID = "mobile-tailwind-cdn";
const CONFIG_ID = "mobile-tailwind-config";
const VARS_ID = "mobile-brand-vars";
const HIDE_ID = "mobile-pre-load-hide";
const READY_CLASS = "mobile-tw-ready";

const MobileTailwind = () => {
  useEffect(() => {
    // Hide mobile-root until Tailwind finishes loading to avoid a flash of unstyled markup
    if (!document.getElementById(HIDE_ID)) {
      const hideStyle = document.createElement("style");
      hideStyle.id = HIDE_ID;
      hideStyle.innerHTML = `
        #mobile-root { visibility: hidden; }
        body.${READY_CLASS} #mobile-root { visibility: visible; }
      `;
      document.head.appendChild(hideStyle);
    }

    if (!document.getElementById(VARS_ID)) {
      const st = document.createElement("style");
      st.id = VARS_ID;
      st.innerHTML = `
        #mobile-root {
          --brand-primary: ${brand.primary};
          --brand-primary-hover: ${brand.primaryHover};
          --brand-primary-disabled: ${brand.primaryDisabled};
          --brand-ink: ${brand.ink};
          --brand-surface: ${brand.surface};
          --brand-platinum: ${brand.platinum};
          --brand-on-primary: ${brand.textOnPrimary};
          font-family: 'Inter', system-ui, sans-serif;
        }
        #mobile-root *, #mobile-root *::before, #mobile-root *::after {
          font-family: 'Inter', system-ui, sans-serif !important;
        }
      `;
      document.head.appendChild(st);
    }

    if (!document.getElementById(CONFIG_ID)) {
      const cfg = document.createElement("script");
      cfg.id = CONFIG_ID;
      cfg.innerHTML = `
        window.tailwind = window.tailwind || {};
        window.tailwind.config = {
          corePlugins: { preflight: false },
          important: '#mobile-root',
          theme: {
            extend: {
              colors: {
                brand: '${brand.primary}',
                'brand-hover': '${brand.primaryHover}',
                gold: '${brand.primary}',
                platinum: '${brand.platinum}',
                ink: '${brand.ink}'
              },
              fontFamily: {
                sansation: ['Inter', 'system-ui', 'sans-serif'],
                opensans: ['Inter', 'system-ui', 'sans-serif'],
                poppins: ['Inter', 'system-ui', 'sans-serif'],
                outfit: ['Inter', 'system-ui', 'sans-serif'],
                inter: ['Inter', 'system-ui', 'sans-serif']
              }
            }
          }
        };
      `;
      document.head.appendChild(cfg);
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement("script");
      s.id = SCRIPT_ID;
      s.src = "https://cdn.tailwindcss.com";
      s.onload = () => {
        document.body.classList.add(READY_CLASS);
      };
      document.head.appendChild(s);
    } else {
      // Already loaded in a previous mount
      document.body.classList.add(READY_CLASS);
    }

  }, []);

  return null;
};

export default MobileTailwind;
